import { Box, Grid } from '@material-ui/core';
import { ArticleType } from '@nemuru-eng/js-api-client';

import { CategorySelector } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/components/CategorySelector';
import { Font } from '@/components/shared/components/Font';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { Text } from '@/components/shared/components/Text';

export const ProductForm = () => {
  return (
    <Box width={'100%'}>
      <Font variant="h4" color="textPrimary">
        <Text strong tId={'PRODUCT_DETAILS'} />
      </Font>
      <Box mt={2} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextFormField name={'item.description'} label={'ARTICLE_DESCRIPTION'} fieldVariant={FieldVariant.form} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CategorySelector type={ArticleType.ONLINE_PRODUCT} textIdSuffix="ARTICLE_CATEGORY" />
        </Grid>
      </Grid>
    </Box>
  );
};
